import { Box } from '@mui/material';
import { DateTime } from 'luxon';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DateCell } from '@work4all/components';

import { remToPx } from '@work4all/data/lib/hooks/useRemToPx';

import { Holiday } from '@work4all/models/lib/Classes/Holiday.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { EditTableColumns } from '../../../containers/mask-overlays/mask-overlay/views/erp/components/tab-panels/positions/components/edit-table/types';
import { DateWheelPickerField } from '../../../containers/statistic/components/date-wheel-picker-field/DateWheelPickerField';
import { EditableEntityTable } from '../editable-entity-table/EditableEntityTable';

const HOLIDAY_DATA: Holiday = {
  id: null,
  date: null,
  name: null,
};

const newEntryMandatoryFields: (keyof Holiday)[] = ['name', 'date'];

const minDate = DateTime.now().minus({ year: 100 }).toJSDate();
const maxDate = DateTime.now().plus({ year: 100 }).toJSDate();

export const HolidayTable = () => {
  const [currentYear, setCurrentYear] = useState(new Date());

  const { t } = useTranslation();

  const cols = useMemo<EditTableColumns<Holiday>[]>(
    () => [
      {
        Header: t('COMMON.DATE'),
        id: 'date',
        accessor: 'date',
        type: 'date',
        Cell: DateCell,
        width: 120,
      },
      {
        Header: t('COMMON.NAME'),
        id: 'name',
        accessor: 'name',
        width: 300,
        type: 'text',
      },
    ],
    [t]
  );

  const toolbarItems = useMemo(() => {
    return (
      <Box width={remToPx(12)}>
        <DateWheelPickerField
          unit="year"
          min={minDate}
          max={maxDate}
          label={t('COMMON.YEAR')}
          value={currentYear}
          onChange={(value) => {
            setCurrentYear(value);
          }}
        />
      </Box>
    );
  }, [currentYear, t]);

  return (
    <EditableEntityTable<Holiday>
      toolbarItemsLeft={toolbarItems}
      columns={cols}
      dataFields={HOLIDAY_DATA}
      entity={Entities.holiday}
      idType="number"
      sortByField="date"
      newEntryMandatoryFields={newEntryMandatoryFields}
      enableDelete
      dataProviderProps={{
        completeDataResponse: true,
        vars: {
          from: DateTime.fromJSDate(currentYear).startOf('year').toISO(),
          to: DateTime.fromJSDate(currentYear).endOf('year').toISO(),
        },
      }}
    />
  );
};
